import React from "react";

const AboutMastaKash = () => {
  return (
    <section className="bg-purple-50 py-20" id="about">
      <div className="max-w-7xl mx-auto px-6 text-center lg:text-left">
        
        {/* Heading */}
        <h2 className="text-4xl font-bold text-purple-900 mb-6">About MastaKash</h2>

        {/* About Text */}
        <p className="text-purple-800 text-lg mb-8">
          MastaKash is a digital financial platform bridging informal community finance (chamas, table banking, merry-go-rounds) and formal banking infrastructure. Founded in 2022 by Ronald Wekesa and Antony Shivere, and based in Kenya, MastaKash empowers individuals and groups to save, invest, and borrow securely while preserving culturally accepted financial practices.
        </p>

        {/* Mission & Vision */}
        <div className="grid gap-8 md:grid-cols-2 mb-12">
          <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <h3 className="text-2xl font-semibold text-purple-900 mb-2">Our Mission</h3>
            <p className="text-purple-800 text-base">
              To empower individuals and communities to organize, protect, and grow their money through secure, accessible, and culturally aligned digital financial tools.
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <h3 className="text-2xl font-semibold text-purple-900 mb-2">Our Vision</h3>
            <p className="text-purple-800 text-base">
              To be the leading platform for bridging informal and formal finance, enabling financial inclusion and sustainable growth across Africa and beyond.
            </p>
          </div>
        </div>

        {/* Core Values */}
        <div>
          <h3 className="text-3xl font-bold text-purple-900 mb-6">Core Values</h3>
          <div className="grid gap-6 md:grid-cols-3">
            {[
              "Security: Protecting users’ funds with purpose-locked sub-wallets.",
              "Transparency: Audit-ready transactions and financial statements.",
              "Inclusion: Accessible to individuals and groups in underserved areas.",
              "Innovation: Continuously improving and digitizing traditional financial practices.",
              "Community Empowerment: Strengthening communities to organize and grow collectively."
            ].map((value, index) => (
              <div key={index} className="bg-white p-5 rounded-xl shadow hover:shadow-lg transition-shadow duration-300">
                <p className="text-purple-800 text-base">{value}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutMastaKash;
